<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div class="autopilot-overrides">
    <div class="algo">
      <selectable-tiles
        :items="pricingStrategies"
        :should-display-labels="true"
        :should-display-icons="true"
        :should-display-checkmark-on-selected-items="true"
        label-property-name="name"
        icon-property-name="icon"
        icon-size="4.8rem"
        :selected-items="selectedBuyingStrategy == null ? [] : [selectedBuyingStrategy]"
        :is-multiselect="false"
        :allow-empty="false"
        :justify-content-left="false"
        tile-width="25%"
        min-tile-width="10rem"
        tile-padding="1.6rem 1rem 1rem"
        @selection-changed="
          (val) => {
            [selectedBuyingStrategy] = val;
          }
        "
        @hovering-on="(item) => (pricingStrategyHoveredOnItem = item)" />
      <div class="alert alert-info">
        {{
          pricingStrategyHoveredOnItem != null
            ? pricingStrategyHoveredOnItem.description
            : selectedBuyingStrategy.description
        }}
      </div>
    </div>

    <!--    <div v-for="section in sections">-->
    <!--      <div class="section">-->
    <!--        <label><b>{{ section.name }} weights</b>-->
    <!--          <span class="ml-3 text-muted">(The bidding agent will favor items with higher weight)</span>-->
    <!--        </label>-->
    <!--        <div class="sliders">-->
    <!--          <div class="slider-container"-->
    <!--               v-for="item in section.items">-->
    <!--            <slider :min="0"-->
    <!--                    :max="10"-->
    <!--                    :value="item.weight"-->
    <!--                    direction="btt"-->
    <!--                    style="height: 10rem"-->
    <!--                    @change="(val) => sectionWeightChanged(section, item, val)"/>-->
    <!--            <label><span v-if="item.entity != null && item.entity.name != null">{{ item.entity.name }}</span></label>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script type="text/babel">
  import { capitalize, markRaw } from 'vue';
  import { mapActions, mapState } from 'vuex';

  import { SelectableTiles } from '@/common/components/controls';
  import { IconColoredRiskAverse, IconColoredRiskSeeking, IconColoredTrueBid } from '@/common/icons/colored';
  import i18n from '@/vueI18n';

  export default {
    components: {
      SelectableTiles,
    },
    props: {
      lineItem: {
        type: Object,
      },
    },
    data() {
      return {
        pricingStrategyHoveredOnItem: null,
        selectedBuyingStrategy: null,
      };
    },
    computed: {
      ...mapState('orgApp', {
        markets: (state) => state.ReferenceData.markets,
        mediaTypes: (state) => state.ReferenceData.mediaTypes,
      }),
      pricingStrategies() {
        return [
          {
            id: 'autopilot',
            name: capitalize(i18n.global.t('messages.buyingStrategyTrueBid')),
            icon: markRaw(IconColoredTrueBid),
            description: i18n.global.t('messages.truBidAutopilot'),
          },
          {
            id: 'risk-averse',
            name: capitalize(i18n.global.t('messages.riskAverse')),
            icon: markRaw(IconColoredRiskAverse),
            description: i18n.global.t('messages.truBidRiskAverse'),
          },
          {
            id: 'risk-seeking',
            name: capitalize(i18n.global.t('messages.riskSeeking')),
            icon: markRaw(IconColoredRiskSeeking),
            description: i18n.global.t('messages.truBidRiskSeeking'),
          },
        ];
      },
      selectedPricingStrategies() {
        if (this.pricingStrategy == null) {
          return this.pricingStrategies[0];
        }
        return this.pricingStrategies.find((x) => x.id === this.pricingStrategy);
      },
      sections() {
        if (this.mediaTypes.length === 0 || this.markets.length === 0) {
          return [];
        }
        const mediaTypeIDs =
          this.lineItem.mediaTypeIDs.length > 0
            ? [...this.lineItem.mediaTypeIDs]
            : [...this.mediaTypes.map((x) => x.id)];
        const marketIDs =
          this.lineItem.marketIDs.length > 0 ? [...this.lineItem.marketIDs] : [...this.markets.map((x) => x.id)];
        return [
          ...(this.lineItem.mediaTypeIDs.length !== 1 && mediaTypeIDs.length <= 10
            ? [
                {
                  name: capitalize(i18n.global.t('names.venueType', { n: 2 })),
                  items: mediaTypeIDs.map((id) => ({
                    entity: this.mediaTypes.find((x) => x.id === id),
                    weight: 5,
                  })),
                },
              ]
            : []),
          ...(this.lineItem.marketIDs.length !== 1 && marketIDs.length <= 10
            ? [
                {
                  name: capitalize(i18n.global.t('names.market', { n: 2 })),
                  items: marketIDs.map((id) => ({
                    entity: this.markets.find((x) => x.id === id),
                    weight: 5,
                  })),
                },
              ]
            : []),
        ];
      },
    },
    methods: {
      capitalize,
      ...mapActions('orgApp', []),
      sectionWeightChanged(section, item, val) {
        item.weight = val;
        this.$emit('weightChanged', this.sections);
      },
    },
    watch: {
      selectedBuyingStrategy() {
        this.$emit('selectedBuyingStrategyChanged', this.selectedBuyingStrategy);
      },
      pricingStrategies() {
        if (this.selectedBuyingStrategy == null) {
          [this.selectedBuyingStrategy] = this.pricingStrategies;
        } else {
          this.selectedBuyingStrategy = this.pricingStrategies.find((x) => x.id === this.selectedBuyingStrategy.id);
        }
      },
    },
    beforeMount() {
      [this.selectedBuyingStrategy] = this.pricingStrategies;
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use 'sass:color';
  @use '@/styles/variables.scss' as *;

  .autopilot-overrides {
    width: 100%;

    .algo {
      padding: 1.6rem;
    }

    .section {
      > label {
        width: 100%;
        padding: 1.6rem;
        font-weight: 600;
        border-top: solid 0.1rem $borders;
        border-bottom: solid 0.1rem $borders-light;
      }

      &:first-of-type {
        > label {
          /*border-top: none;*/
        }
      }

      .sliders {
        display: flex;
        flex-wrap: wrap;

        .slider-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex-basis: 20%;

          label {
            margin-top: 1rem;
          }
        }
      }
    }
  }
</style>
